import React from 'react';
import './Home.js.css';
import Container from '../components/Container';
import '../styles/generics.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PageComponent from '../components/PageComponent';
import Labels from '../Labels';
import Connection from '../config/Connection';
import { Link } from 'react-router-dom';
import Parsers from '../Tools/Parsers';
import MaskedInput from '../components/MaskedInput';
import ProgramDetailPage from './ProgramDetailPage';
import ErrorComponent from '../components/ErrorComponent';

export default class ProgramGoalsPage extends PageComponent {

  static PageInfo = {

    path: "/Program/Detail/:id/Goals",
    name: "menu.programgoals",
    parent: ProgramDetailPage,
    hidden: true,
    permission: { "GOAL_LISTING": true },
    icon: "cubes"
  }

  constructor(props) {
    super(props);
    this.data = props.match.params;
    this.state.modalError = null;
    this.state.loading = true;
  }

  componentDidMount() {

    Connection.Secure(Connection.service + 'ToDo/Program/' + this.data.id)
      .then((response) => {
        if (response.ok && response.status == 200)
          response.json().then((data) => {
            var f = {}, r = [];
            if (Array.isArray(data) && data.length > 0) {
              data = data[0];
              this.clients = data.clientDetails;
              for (let i = 0; i < data.toDos.length; i++)
                if (typeof f[data.toDos[i].status] === "undefined") f[data.toDos[i].status] = null;

              for (var i in f) r.push(i);
              r.sort();
            }
            setTimeout(() => this.setState({ data: data.toDos, info: data, loading: false, filter: r, filteredData: data.toDos }));
          });
        else this.setState({ error: response, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error, loading: false });
      });
  }

  doFilter(v) {
    this.setState({
      filteredData: v == null ? this.state.data : this.state.data.filter((item) => {
        return item.status == v;
      })
    });
  }

  renderClient(item) {
    var c = null;
    for (let i = 0; i < this.clients.length && c == null; i++) {
      const element = this.clients[i];
      if (element.customerCode == item.mainCompany.keyRegister)
        c = element;
    }
    return c == null ? null :
      <Link to={"/Program/Detail/" + this.data.id + "/Goal/" + item.mainCompany.keyRegister + (Parsers.parsePermission2(["GOAL_ACCESS"]) ? "" : "/QualitativeAward/")} className="generics_listing_item" >
        <FontAwesomeIcon icon={Parsers.GetStatusIcon(item.status)} className="generics_listing_item_icon" style={{
          opacity: 1, color: Parsers.GetStatusColor(item.status)
        }} />
        <div className="generics_listing_content" >
          <div>#{c.customerCode}</div>
          <div className="generics_listing_item_title" >{c.name1 + (c.name2 == null ? "" : c.name2)
            + (c.name3 == null ? "" : c.name3)
            + (c.name4 == null ? "" : c.name4)}</div>
          <div className="generics_listing_item_description" >
            <div style={{ float: "left" }}>{Parsers.parseCPNJ(c.cnpjCode)}</div>
            <div style={{ float: "right", marginLeft: 10 }}>{c.headOfficeAcc != null ? Labels.GetLabel("program.hierarchy_false") + " (#" + c.headOfficeAcc + ")" : Labels.GetLabel("program.hierarchy_true")}</div>
            <div style={{ clear: "both" }}></div>
            <div className="generics_listing_item_description" style={{ textAlign: "right", fontWeight: "bold" }} >{Labels.GetLabel("generic.goal")}: {Parsers.parseNumber(item.data.goal, true)}</div>
            <div className="generics_listing_item_description" style={{ textAlign: "right" }} >{Labels.GetLabel("STATUS_PROGRAM." + item.status)}</div>
          </div>
        </div>
      </Link>
  }

  renderClients() {
    if (this.state.filteredData == null || this.state.filteredData.length == 0)
      return <div className="generic_empty">{Labels.GetLabel("generic.noresultfound")}</div>
    else {
      return this.state.filteredData.map(item => this.renderClient(item));
    }
  }

  render() {
    return (
      <Container context={this.constructor}>

        {
          this.state.error != null ? <ErrorComponent error={this.state.error} /> :
            this.state.loading ? <div>{Labels.GetLabel("generic.loading")}</div> :
              <div className="generics_panels" style={{ flexDirection: "column", flex: 1 }}>
                <div className="generics_panels_header"><FontAwesomeIcon icon={this.constructor.PageInfo.icon} /> <span> {this.state.info.program.brand.label + " - " + this.state.info.program.label}</span>
                  <div>{Labels.GetLabel(this.state.info.program.fkClientType == null ? "generic.all" : 'CLIENT_TYPE.' + this.state.info.program.fkClientType)}</div></div>

                <div className="generics_panels" style={{}}>
                  <div style={{ width: 300, maxWidth: "20%", minWidth: 200 }}>


                    <MaskedInput type="select" onValid={(value) => { this.doFilter(Array.isArray(value) ? value[0] : null) }} label={Labels.GetLabel("generic.status")}
                      onInvalid={(value) => this.setState({ region: null })} parser={(t) => Labels.GetLabel("STATUS_PROGRAM." + t)} data={() => { return this.state.filter }} placeholder={Labels.GetLabel("generic.allstates")} />
                  </div>
                  <div className="generics_panels_flex1">
                    <div className="generics_panels_header"><FontAwesomeIcon icon="list" /> <span>{Labels.GetLabel(this.constructor.PageInfo.name)} - {Labels.GetLabel("clients.results")} ({Array.isArray(this.state.filteredData) ? this.state.filteredData.length : 0})</span></div>
                    <div>{
                      this.renderClients()
                    }
                    </div>
                  </div>
                </div>
              </div>
        }
      </Container >
    );
  }
}